import { render, staticRenderFns } from "./InitiateRecording.vue?vue&type=template&id=8ac05b48&scoped=true&"
import script from "./InitiateRecording.vue?vue&type=script&lang=ts&"
export * from "./InitiateRecording.vue?vue&type=script&lang=ts&"
import style0 from "./InitiateRecording.vue?vue&type=style&index=0&id=8ac05b48&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac05b48",
  null
  
)

export default component.exports